module.exports = __webpack_public_path__ + "media/images/article-image-a914c2c508d0fb84ca9a46f9c5e6d63e.jpg";